import { POPUP_SECTIONS } from "../../../../constant/constant";
import TextBlock from "../../Draggable/Block/TextBlock";
import ButtonBlock from "../../Draggable/Block/ButtonBlock";
import CoverImageBlock from "../../Draggable/Block/CoverImageBlock";
import QuantityPickerBlock from "../../Draggable/Block/QuantityPickerBlock";
import VariantPickerBlock from "../../Draggable/Block/VariantPickerBlock";
import PriceBlock from "../../Draggable/Block/PriceBlock";
import RatingBlock from "../../Draggable/Block/RatingBlock";
import ProductDescriptionBlock from "../../../../layouts/checkout-extension/post-purchase/ProductDescriptionBlock";

export function renderCatalogSubBlock({
  type,
  productData,
  productIndex,
  productSection,
  productSectionIndex,
  popupData,
  popupState,
  setPopupState,
  activeStep,
  handleClose,
  isMobile,
  forceCompactCoverImage = false,
  fixedCatalogSlot = true,
  preferCatalogHeroFrame = false,
  fillParentSlot = false,
  catalogLineClamp,
  catalogCompactPrice = false,
  catalogCompactAdded = false,
  surface = "cart-drawer",
}) {
  switch (type) {
    case POPUP_SECTIONS.TITLE:
      return (
        <TextBlock
          popupData={popupData}
          activeStep={activeStep}
          section={productSection}
          parentData={productData}
          catalogFlow
          catalogLineClamp={catalogLineClamp}
          surface={surface}
        />
      );
    case POPUP_SECTIONS.COVER_IMAGE:
      return (
        <CoverImageBlock
          section={productSection}
          productIndex={productIndex}
          productData={productData}
          popupData={popupData}
          activeStep={activeStep}
          forceCompactLayout={forceCompactCoverImage}
          fixedCatalogSlot={fixedCatalogSlot}
          preferCatalogHeroFrame={preferCatalogHeroFrame}
          fillParentSlot={fillParentSlot}
        />
      );
    case POPUP_SECTIONS.PRICE:
      return (
        <PriceBlock
          productData={productData}
          section={productSection}
          index={productSectionIndex}
          productIndex={productIndex}
          popupData={popupData}
          catalogCompactPrice={catalogCompactPrice}
        />
      );
    case POPUP_SECTIONS.RATING:
      return <RatingBlock section={productSection} catalogFlow />;
    case POPUP_SECTIONS.DESCRIPTION:
      return (
        <ProductDescriptionBlock
          section={productSection}
          productData={productData}
          popupData={popupData}
          activeStep={activeStep}
          productIndex={productIndex}
        />
      );
    case POPUP_SECTIONS.VARIANT_PICKER:
      return (
        <VariantPickerBlock
          popupData={popupData}
          section={productSection}
          index={productSectionIndex}
          productIndex={productIndex}
          productData={productData}
        />
      );
    case POPUP_SECTIONS.QUANTITY_PICKER:
      return (
        <QuantityPickerBlock
          section={productSection}
          index={productSectionIndex}
          productIndex={productIndex}
          popupData={popupData}
          activeStep={activeStep}
          stretchFullWidth
        />
      );
    case POPUP_SECTIONS.BUTTON:
      return (
        <ButtonBlock
          popupData={popupData}
          popupState={popupState}
          setPopupState={setPopupState}
          section={productSection}
          index={productSectionIndex}
          productIndex={productIndex}
          productData={productData}
          handleClose={handleClose}
          compactAddedLabel={catalogCompactAdded}
        />
      );
    default:
      return null;
  }
}
